import { createFileRoute } from "@tanstack/react-router";
import { FeatureFlagsPage } from "../../../../../pages";

export const Route = createFileRoute(
  "/_authenticated/_layout/_main/_centered/flags",
)({
  component: FeatureFlagsPage,
});
